import { useTranslation } from "react-i18next";
import { Box, Button, Group, Image, Text, UnstyledButton } from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons-react";
import DetailSection from "../common/DetailSection";
import userBank from "../images/user-bank.png";
import {
  NOTIFICATION_DETAIL,
  NOTIFICATIONS,
} from "../constants/drawer.constant";
import DrawerLayout from "./DrawerLayout";

interface DrawerProps {
  activeDrawer: any;
  setActiveDrawer: any;
}
const NotificationDetailDrawer = ({
  activeDrawer,
  setActiveDrawer,
}: DrawerProps) => {
  const { t } = useTranslation();
  const title = (
    <Group
      px="md"
      style={{
        borderBottom: "1px solid #F0F2F7",
        position: "sticky",
        top: 0,
        backgroundColor: "#FDFDFD",
        zIndex: 100,
        height: "64px",
        color: "#0D0D0D",
      }}
    >
      <UnstyledButton onClick={() => setActiveDrawer(NOTIFICATIONS)}>
        <IconArrowLeft size={24} stroke={1.5} />
      </UnstyledButton>
      <Text size="lg" fw={700}>
        {t("PROMOTION_DETAIL")}
      </Text>
    </Group>
  );
  const content = (
    <Box
      sx={{
        padding: "20px",
        color: "#131618",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
      }}
    >
      <Image src={userBank} radius="md" sx={{ height: "100%" }} />

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          padding: "0 12px",
        }}
      >
        <DetailSection
          title={t("COST_SAVINGS")}
          content={t("COST_SAVINGS_DESCRIPTION")}
        />
        <DetailSection
          title={t("EASE_OF_USE")}
          content={t("EASE_OF_USE_DESCRIPTION")}
        />
        <DetailSection
          title={t("HIGH_SECURITY")}
          content={t("HIGH_SECURITY_DESCRIPTION")}
        />
      </Box>
    </Box>
  );
  const bottom = (
    <Group
      sx={{
        justifyContent: "flex-end",
        gap: "md",
        fontSize: "14px",
        fontWeight: 700,
      }}
    >
      <Button
        variant="outline"
        radius="8px"
        px={24}
        py={10}
        color="#2A81D0"
        onClick={() => setActiveDrawer("notfications")}
        style={{ border: "none", borderRadius: "8px" }}
      >
        {t("OK_GOT_IT")}
      </Button>
      <Button
        sx={{
          backgroundColor: "#2A81D0",
          color: "white",
          padding: "10px 24px",
          borderRadius: "8px",
        }}
      >
        {t("LET_ME_EXPLORE")}
      </Button>
    </Group>
  );
  return (
    <DrawerLayout
      opened={activeDrawer === NOTIFICATION_DETAIL}
      onClose={() => setActiveDrawer(NOTIFICATIONS)}
      title={title}
      content={content}
      bottom={bottom}
    />
  );
};

export default NotificationDetailDrawer;
